// extracted by mini-css-extract-plugin
module.exports = {"Header":"DocViewerError_Header__MVkgL","HeaderItems":"DocViewerError_HeaderItems__1HurW","Button":"DocViewerError_Button__3JU1W"};